// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fVtf","left":"styles_left__TAQMd","desktopActions":"styles_desktopActions__1yeaP","title":"styles_title__AZrto"};